import { err, ok, type Result } from "neverthrow";
import {
  cardsResponseSchema,
  type CardsRequest,
  type CardsResponse,
} from "@go-novus/admin-api";
import { widgetBusinessFetch } from "./business-fetch";
export type CardsFailure = "rate_limited" | "upstream_unavailable";
export async function requestCards(
  handshakeUrl: string,
  input: CardsRequest,
  fetchImpl: typeof fetch = widgetBusinessFetch(handshakeUrl),
): Promise<Result<CardsResponse, CardsFailure>> {
  try {
    const url = new URL(handshakeUrl, window.location.href);
    url.pathname = url.pathname.replace(/\/handshake$/, "/cards");
    const response = await fetchImpl(url.href, {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(input),
      signal: AbortSignal.timeout(15_000),
    });
    if (!response.ok)
      return err(
        response.status === 429 ? "rate_limited" : "upstream_unavailable",
      );
    const parsed = cardsResponseSchema.safeParse(await response.json());
    return parsed.success ? ok(parsed.data) : err("upstream_unavailable");
  } catch {
    return err("upstream_unavailable");
  }
}
